import { Box, BoxProps, Heading, Text } from "@vinomofo/components";

import { COLORS } from "../../styles";
import { UrgencyMessage } from "../../types";
import styled from "styled-components";

export interface OfferCtaMessageProps extends BoxProps {
  message: UrgencyMessage;
  isTierEligible?: boolean;
}

const StyledText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OfferCtaMessage = ({
  message,
  isTierEligible,
  ...rest
}: OfferCtaMessageProps): JSX.Element => {
  let el = null;
  if (isTierEligible) {
    el = (
      <Box
        bg={COLORS.black}
        px="10px"
        {...rest}
        style={{ justifyContent: "center" }}
      >
        <Box mb={0} padding="4px" display="flex" justifyContent="center">
          <Heading
            as="span"
            variant="xxs"
            color="primary"
            lineHeight="none"
            fontWeight={900}
            fontSize="12px"
          >
            VIM
          </Heading>
          <Heading
            as="span"
            variant="xxs"
            color="white"
            lineHeight="none"
            fontWeight={100}
            fontSize="12px"
          >
            &nbsp; Exclusive
          </Heading>
        </Box>
      </Box>
    );
  } else {
    let bg = message?.backgroundColor
      ? COLORS[message?.backgroundColor]
      : message?.backgroundColor;
    el = (
      <Box bg={bg} px="10px" {...rest}>
        <StyledText
          textAlign="center"
          fontSize={["12px", "13px"]}
          fontWeight={600}
          color="white"
        >
          {message?.description}
        </StyledText>
      </Box>
    );
  }
  return el;
};
